module.exports = __webpack_public_path__ + "static/img/3_6_2.55838d4c.jpg";